<template>
  <p>
    <span style="color: rgba(0, 0, 0, 0.54); font-size: 10px; display: block">
      {{ label }}
    </span>
    <span style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); display: block">
      {{ value }}
    </span>
  </p>
</template>

<script>
export default {
  name: "InfoField",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>
